exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fc-toolbar .fc-center h2{font-size:1.4rem;margin-bottom:0}.fc-content{padding:3px 4px;font-size:.7rem}.fc-content .fc-title{display:block}.p-user-reservation .p-user-reservation__times{height:320px;overflow-y:scroll}.p-user-reservation .p-user-reservation__times .table th{display:none}.p-user-reservation .p-user-reservation__times .table td{font-size:.8rem}.c-fullcalendar-reservation .fc-row .fc-content-skeleton .fc-event-container{position:relative;top:-12px}.c-fullcalendar-reservation span.current-date{color:#fff!important;background-color:#ef7320!important}", ""]);

// exports
